import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { alertActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getAIAgenciesApi,
  createAIAgencyApi,
  updateAIAgencyApi,
  deleteAIAgencyApi,
} from "services/accountInquiry/accountInquiry.thunks";
import AgencyCreate from "../../components/AgencyCreate";
import ManageAgencyTable from "../../components/AgencyTable";
import { ERR_MSG } from "constants/labels";

const ManageAIAgency = () => {
  const header = "Manage AI Agency";
  const dispatch = useDispatch();
  const [rawTableData, setRawTableData] = useState([]);

  const fetchAgencies = async () => {
    try {
      const res = await dispatch(getAIAgenciesApi()).unwrap();
      if (!res || !res?.Succeeded) {
        dispatch(
          alertActions.error({
            message: res?.Message || ERR_MSG["073"],
            header,
          }),
        );
        return;
      }
      setRawTableData(res?.Data || []);
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header,
        }),
      );
    }
  };

  useEffect(() => {
    fetchAgencies();
  }, []);

  return (
    <>
      <Typography component="div" className="userprofilelist">
        <Grid container direction="row" spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>
            <Typography variant="h2" className="userprofilelistcontent">
              {header}
            </Typography>
          </Grid>
        </Grid>
      </Typography>
      <Grid container justifyContent={"flex-end"} alignItems={"center"}>
        {rawTableData && (
          <AgencyCreate
            agencies={rawTableData}
            handleRefresh={fetchAgencies}
            createApi={createAIAgencyApi}
            header={header}
            title="Create AI Agency"
            buttonLabel="Agency"
            portalID={1}
          />
        )}
      </Grid>
      <Typography component="div">
        {rawTableData && (
          <ManageAgencyTable
            portalID={1}
            rawTableData={rawTableData}
            handleRefresh={fetchAgencies}
            updateApi={updateAIAgencyApi}
            deleteApi={deleteAIAgencyApi}
            header={header}
            emptyMessage="No AI agency data found."
          />
        )}
      </Typography>
    </>
  );
};

export default ManageAIAgency;
